import type { ComponentPropsWithRef, HtmlHTMLAttributes } from 'react';

type VisuallyHiddenInputProps = HtmlHTMLAttributes<HTMLInputElement> &
  ComponentPropsWithRef<any>;

export const VisuallyHiddenInput = (props: VisuallyHiddenInputProps) => {
  return (
    <input
      {...props}
      style={{
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
      }}
    />
  );
};
